import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

export const categoryTitle = '組織開発・人材育成'
export const baseUrl = '/cases/hip'

const Hip: React.FC = () => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={1} />
}

export default Hip
